import React from 'react';
import './TutorialVideosLayout.css';

export function TutorialVideosLayout({ sidebar, content }) {
  return (
    <div className="tutorial-videos-layout">
      {/* Left Sidebar */}
      <aside className="tutorial-videos-sidebar">
        {sidebar}
      </aside>

      {/* Main Content Area */}
      <main className="tutorial-videos-content">
        {content}
      </main>
    </div>
  );
}